import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3c771252"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "p-jobsearch-list_item" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = ["checked"]
const _hoisted_4 = {
  key: 1,
  class: "p-jobsearch-list_item_check disabled"
}
const _hoisted_5 = { class: "p-jobsearch-card_inner" }
const _hoisted_6 = { class: "p-jobsearch-card_header" }
const _hoisted_7 = { class: "p-jobsearch-tag01" }
const _hoisted_8 = {
  key: 0,
  class: "p-jobsearch-tag01_item __closed js-tooltip-open-button"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "募集終了", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "p-jobsearch-tooltip js-tooltip-container" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "p-jobsearch-tooltip_inner" }, [
    /*#__PURE__*/_createElementVNode("p", null, "募集終了ではありますが、応募対応は可能です。同企業の別ポディションで検討いたします。")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "p-jobsearch-tooltip_close js-tooltip-close-trigger" }, "閉じる")
], -1))
const _hoisted_11 = [
  _hoisted_9,
  _hoisted_10
]
const _hoisted_12 = { class: "p-jobsearch-heading word_break" }
const _hoisted_13 = { class: "p-jobsearch-company" }
const _hoisted_14 = { class: "p-jobsearch-tit" }
const _hoisted_15 = { class: "p-jobsearch-tag02" }
const _hoisted_16 = {
  key: 0,
  class: "p-jobsearch-tag02_item __welcome"
}
const _hoisted_17 = {
  key: 1,
  class: "p-jobsearch-tag02_item __blank"
}
const _hoisted_18 = ["href"]
const _hoisted_19 = { class: "p-jobsearch-data" }
const _hoisted_20 = { key: 0 }
const _hoisted_21 = { key: 1 }
const _hoisted_22 = { class: "p-jobsearch-outline" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("dt", { class: "__income" }, "年収", -1))
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("dt", { class: "__place" }, "勤務地", -1))
const _hoisted_25 = { class: "word_break" }
const _hoisted_26 = { class: "__job" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("dt", { class: "__job" }, "仕事内容", -1))
const _hoisted_28 = { class: "__job" }
const _hoisted_29 = {
  key: 0,
  class: "p-jobsearch-comment"
}
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "p-jobsearch-comment_heading" }, "担当者コメント", -1))
const _hoisted_31 = { class: "word_break" }
const _hoisted_32 = {
  key: 1,
  class: "p-jobsearch-btn __applied"
}
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "p-jobsearch-btn_ico" }, null, -1))
const _hoisted_34 = {
  key: 2,
  class: "p-jobsearch-heart js-heart __animation"
}
const _hoisted_35 = ["checked"]
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "p-jobsearch-heart_icon" }, null, -1))
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "p-jobsearch-heart_txt" }, "気になる", -1))
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "p-jobsearch-heart_bubble" }, [
  /*#__PURE__*/_createElementVNode("span"),
  /*#__PURE__*/_createElementVNode("span"),
  /*#__PURE__*/_createElementVNode("span"),
  /*#__PURE__*/_createElementVNode("span"),
  /*#__PURE__*/_createElementVNode("span"),
  /*#__PURE__*/_createElementVNode("span")
], -1))

import { ref } from 'vue';

import { Job } from '@/types';

import { onMounted } from 'vue';
import { MYPAGE_CONSTANTS } from '@/constants/mypage';
import { getCheckApply, getCheckReApply } from '@/api/shintyokuEndpoint';
import store from '@/store';
import router from '@/router';
import { getMessageForInvalidOrders } from '@/utils/messageFormat';

export default /*#__PURE__*/_defineComponent({
  __name: 'JobListItem',
  props: {
    job: null,
    isBulkSelectionEnabled: { type: Boolean },
    screenName: null,
    isNotShowHeart: { type: Boolean },
    fromScreen: null,
    isPublicOrderDetail: { type: Boolean }
  },
  emits: [
  'update:checked',
  'update:favorite',
  'writeLog:pickUp',
  'writeLog:orderVideo',
  'turn-action',
  'save-scroll-top'
],
  setup(__props: any, { emit }) {

const props = __props as {
  job: Job;
  isBulkSelectionEnabled: boolean;
  screenName?: string;
  isNotShowHeart?:boolean;
  fromScreen?: string;
  isPublicOrderDetail?: boolean
}



const isApplied = ref(false);



const handleLabelClick = () => {
  // 親コンポーネントにイベントを通知
  // 親コンポーネントのロジックで上限チェックとアラート表示を行う
  emit('update:checked', !props.job.checked);
};

const handleCheckboxChange = (event: Event) => {
  emit('update:checked', (event.target as HTMLInputElement).checked);
};

const handleFavoriteChange = (event: Event) => {
  emit('update:favorite', (event.target as HTMLInputElement).checked);
};


const handleWriteLogPickup = (event: Event) => {
  emit('writeLog:pickUp', (event.target as HTMLInputElement).click);
};

const turnAction = (turnValue: boolean) => {
  emit('turn-action', turnValue);
}

const handleClickDetail = () => {
  emit('save-scroll-top');
};

// src/js/_module/_tooltip.ts
function initializeTooltips() {
  const tooltipOpenButtons = document.querySelectorAll('.js-tooltip-open-button');
  tooltipOpenButtons.forEach((button) => {
    button.addEventListener('click', () => {
      const tooltipContainer = button.querySelector('.js-tooltip-container');
      if (tooltipContainer) {
        document.querySelectorAll('.js-tooltip-container.is-active').forEach((openTooltip) => {
          if (openTooltip !== tooltipContainer) {
            openTooltip.classList.remove('is-active');
          }
        });
        tooltipContainer.classList.add('is-active');
      }
    });
  });
  const tooltipCloseTriggers = document.querySelectorAll('.js-tooltip-close-trigger');
  tooltipCloseTriggers.forEach((trigger) => {
    trigger.addEventListener('click', (event) => {
      event.stopPropagation();
      const tooltipContainer = trigger.closest('.js-tooltip-container');
      if (tooltipContainer) {
        tooltipContainer.classList.remove('is-active');
      }
    });
  });
      document.addEventListener('click', (event) => {
    const openTooltips = document.querySelectorAll('.js-tooltip-container.is-active');
    openTooltips.forEach((tooltip) => {
      const openButton = tooltip.parentElement;
      if (openButton && !openButton.contains(event.target) && !tooltip.contains(event.target)) {
        tooltip.classList.remove('is-active');
      }
    });
  });
}

function checkApplied(){
  const statusId = props.job.statusId;
  if(MYPAGE_CONSTANTS.TRNSHINTYOKU_STATUS.STATUS_AFTER_APPLY.includes(statusId) && props.job.isApply && !props.job.isRefusal){
    isApplied.value = true;
  }
}

async function checkProgress(type: string){
  turnAction(false);
  let res;
  if(type == "reApply"){
    res = await getCheckReApply(props.job.orderId);
  }else{
    res = await getCheckApply(props.job.orderId);
  }

  if(res && res.responseFaultDetail){
    const order = [{ orderId: Number(props.job.orderId), realClientName: props.job.companyName, positionName: props.job.jobTitle }];
    turnAction(true);
    if(res.responseFaultDetail.ignoredOrder){
      store.dispatch('toasts/appendTimeToast', {label: MYPAGE_CONSTANTS.STRING.IGNORED_ORDER_ERR_MESG_SINGLE + getMessageForInvalidOrders(order)});
    }else if(res.responseFaultDetail.reApplyDeniedOrder){
      if(type == "reApply"){
        store.dispatch('toasts/appendTimeToast', {label: MYPAGE_CONSTANTS.STRING.REAPPLY_DENY_MESG + getMessageForInvalidOrders(order)});
      }else{
        store.dispatch('toasts/appendTimeToast', {label: MYPAGE_CONSTANTS.STRING.NO_SEL_ON_BRIEFING_SESSION + getMessageForInvalidOrders(order)});
      }
    } else {
      store.dispatch('toasts/appendTimeToast', {label: MYPAGE_CONSTANTS.STRING.FAIL_UPDATE_PROGRESS_MSG});
    }
    
  }else{
    turnAction(true);
    router.push('/apply/form/' + props.job.orderId + '/' + type);
  }
}

onMounted(() => {
  initializeTooltips();
  checkApplied();
});

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (__props.isBulkSelectionEnabled && (!__props.job.isApply || __props.job.isRefusal))
      ? (_openBlock(), _createElementBlock("label", {
          key: 0,
          class: "p-jobsearch-list_item_check",
          onClick: _withModifiers(handleLabelClick, ["prevent"])
        }, [
          _createElementVNode("input", {
            class: "js-check-jobitem",
            type: "checkbox",
            checked: __props.job.checked,
            onChange: handleCheckboxChange
          }, null, 40, _hoisted_3)
        ], 8, _hoisted_2))
      : _createCommentVNode("", true),
    (__props.isBulkSelectionEnabled && (__props.job.isApply && !__props.job.isRefusal ))
      ? (_openBlock(), _createElementBlock("label", _hoisted_4))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: _normalizeClass(["p-jobsearch-card", __props.job.recruitClosed ? '__closed' : ''])
    }, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("ul", _hoisted_7, [
            (__props.job.recruitClosed)
              ? (_openBlock(), _createElementBlock("li", _hoisted_8, _hoisted_11))
              : _createCommentVNode("", true),
            (__props.job.isRecommendedByStaff)
              ? (_openBlock(), _createElementBlock("li", {
                  key: 1,
                  class: _normalizeClass(["p-jobsearch-tag01_item", __props.job.recruitClosed ? '__gray' : ''])
                }, "担当者おすすめ", 2))
              : (__props.job.isRecommendedByClient)
                ? (_openBlock(), _createElementBlock("li", {
                    key: 2,
                    class: _normalizeClass(["p-jobsearch-tag01_item", __props.job.recruitClosed ? '__gray' : ''])
                  }, "弊社企業担当おすすめ", 2))
                : (__props.job.isNewRecommended)
                  ? (_openBlock(), _createElementBlock("li", {
                      key: 3,
                      class: _normalizeClass(["p-jobsearch-tag01_item", __props.job.recruitClosed ? '__gray' : ''])
                    }, "新着レコメンド", 2))
                  : (__props.job.isAiRecommended)
                    ? (_openBlock(), _createElementBlock("li", {
                        key: 4,
                        class: _normalizeClass(["p-jobsearch-tag01_item", __props.job.recruitClosed ? '__gray' : ''])
                      }, "AIおすすめ", 2))
                    : (__props.job.isLiked || __props.job.isJobSearchPublic)
                      ? (_openBlock(), _createElementBlock("li", {
                          key: 5,
                          class: _normalizeClass(["p-jobsearch-tag01_item __public", __props.job.recruitClosed ? '__gray' : ''])
                        }, "公開求人から検索", 2))
                      : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("p", _hoisted_13, _toDisplayString(__props.job.companyName), 1),
            _createElementVNode("h2", _hoisted_14, [
              _createVNode(_component_router_link, {
                to: `/jobsearch/detail/${__props.job.orderId}${__props.isPublicOrderDetail && __props.fromScreen == 'pending' ? '/public' : ''}`,
                onClick: handleClickDetail
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(__props.job.jobTitle), 1)
                ]),
                _: 1
              }, 8, ["to"])
            ])
          ]),
          _createElementVNode("ul", _hoisted_15, [
            (__props.job.isWelcome)
              ? (_openBlock(), _createElementBlock("li", _hoisted_16, "応募歓迎"))
              : _createCommentVNode("", true),
            (__props.job.pickupLink)
              ? (_openBlock(), _createElementBlock("li", _hoisted_17, [
                  _createElementVNode("a", {
                    href: __props.job.pickupLink || '#',
                    target: "_blank",
                    onClick: handleWriteLogPickup
                  }, "PICK UP", 8, _hoisted_18)
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("p", _hoisted_19, [
            (__props.job.introductionDate)
              ? (_openBlock(), _createElementBlock("span", _hoisted_20, "紹介日：" + _toDisplayString(__props.job.introductionDate), 1))
              : _createCommentVNode("", true),
            _createTextVNode(),
            (__props.job.orderId)
              ? (_openBlock(), _createElementBlock("span", _hoisted_21, "求人ID：" + _toDisplayString(__props.job.orderId), 1))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("dl", _hoisted_22, [
          _hoisted_23,
          _createElementVNode("dd", null, _toDisplayString(__props.job.annualIncome), 1),
          _hoisted_24,
          _createElementVNode("dd", _hoisted_25, _toDisplayString(__props.job.workLocation), 1),
          _createElementVNode("div", _hoisted_26, [
            _hoisted_27,
            _createElementVNode("dd", _hoisted_28, _toDisplayString(__props.job.jobDescription), 1)
          ])
        ]),
        (__props.job.staffComment)
          ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
              _hoisted_30,
              _createElementVNode("p", _hoisted_31, _toDisplayString(__props.job.staffComment), 1)
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", {
          class: _normalizeClass({
      'p-jobsearch-buttons-noheart': __props.isNotShowHeart,
      'p-jobsearch-buttons': !__props.isNotShowHeart
        })
        }, [
          (!isApplied.value)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                (__props.screenName == 'public')
                  ? (_openBlock(), _createBlock(_component_router_link, {
                      key: 0,
                      class: "p-jobsearch-btn __blue",
                      to: `/apply/form/${__props.job.orderId}/${props.screenName}`
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(" 応募する ")
                      ]),
                      _: 1
                    }, 8, ["to"]))
                  : (_openBlock(), _createElementBlock("span", {
                      key: 1,
                      class: "p-jobsearch-btn __blue",
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (checkProgress(props.screenName)))
                    }, "応募する"))
              ], 64))
            : (_openBlock(), _createElementBlock("span", _hoisted_32, "応募済み")),
          _createVNode(_component_router_link, {
            class: "p-jobsearch-btn __white __link",
            to: `/jobsearch/detail/${__props.job.orderId}${__props.isPublicOrderDetail && __props.fromScreen == 'pending' ? '/public' : ''}`,
            onClick: handleClickDetail
          }, {
            default: _withCtx(() => [
              _createTextVNode(" 詳細を見る"),
              _hoisted_33
            ]),
            _: 1
          }, 8, ["to"]),
          (!(__props.isNotShowHeart))
            ? (_openBlock(), _createElementBlock("label", _hoisted_34, [
                _createElementVNode("input", {
                  type: "checkbox",
                  checked: __props.job.isFavorite || __props.job.isLiked,
                  onChange: handleFavoriteChange
                }, null, 40, _hoisted_35),
                _hoisted_36,
                _hoisted_37,
                _hoisted_38
              ]))
            : _createCommentVNode("", true)
        ], 2)
      ])
    ], 2)
  ]))
}
}

})